// extracted by mini-css-extract-plugin
export default {"dialog":"TestSelection_tsx_dialog__YyRAg","container":"TestSelection_tsx_container__IoWsK"};